import React, { useEffect, useState } from "react";
import AddContributionsModal from "./AddContributionsModal";
import { useTranslation } from "react-i18next";
import {
  getContributions,
  updateContribution,
  deleteContribution,
} from "../../../Api/Speakers/Contributions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactPaginate from "react-paginate";
import { createContribution } from "../../../Api/Speakers/Contributions";

const ContributionsManagement = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [contributionData, setcontributionData] = useState({
    items: [],
    total: 0,
  });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  toast.dismiss();

  const [formData, setFormData] = useState({
    titleArabic: "",
    titleEnglish: "",
    arabicOrganizationName: "",
    englishOrganizationName: "",
    participationType: "",
    arabicDescription: "",
    englishDescription: "",
    location: "",
    language: "",
    eventDate: "",
    eventTime: "",
    isOnline: null,
    contributeOn: "",
    imagePath: null,
    link: "",
  });

  const fetchContributions = async () => {
    setLoading(true);
    try {
      const response = await getContributions({ page });
      setcontributionData({
        items: response.data.items || [],
        total: response.data.metadata?.totalCount || 0,
      });
    } catch (error) {
      console.error("Error fetching contributions:", error);
      toast.error("فشل في تحميل المساهمات");
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setSelectedItem(null); // تفريغ البيانات
    setIsEdit(false);
    setShowModal(true);
  };
  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsEdit(true);
    setShowModal(true);
  };
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("هل أنت متأكد من حذف هذا المساهمة؟");
    if (!confirmDelete) return;

    try {
      await deleteContribution(id);
      setcontributionData((prev) => ({
        ...prev,
        items: prev.items.filter((item) => item.id !== id),
      }));
      toast.success("تم الحذف بنجاح");
    } catch (error) {
      toast.error("حدث خطأ أثناء الحذف");
      console.error(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "location") {
      setFormData((prev) => ({
        ...prev,
        location: value,
        isOnline: value === "online",
      }));
    } else if (name === "eventDate" || name === "eventTime") {
      const currentDate =
        formData.eventDate || new Date().toISOString().split("T")[0];
      const currentTime = formData.eventTime || "00:00";
      const dateTimeString = `${currentDate}T${currentTime}:00.000Z`;

      setFormData((prev) => ({
        ...prev,
        [name]: value,
        contributeOn: dateTimeString,
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    toast.dismiss();

    // التحقق من الحقول
    if (!formData.participationType) {
      toast.error(t("addContributions.selectParticipationType"));
      return;
    }
    if (!formData.language) {
      toast.error(t("addContributions.selectLanguage"));
      return;
    }
    if (!formData.location) {
      toast.error(t("addContributions.selectLocation"));
      return;
    }

    const dateTime = new Date(formData.eventDate);
    if (formData.eventTime) {
      const [hours, minutes] = formData.eventTime.split(":");
      dateTime.setHours(parseInt(hours), parseInt(minutes));
    }

    const contributionData = {
      arabicTitle: formData.titleArabic,
      englishTitle: formData.titleEnglish,
      arabicOrganizationName: formData.arabicOrganizationName,
      englishOrganizationName:
        formData.englishOrganizationName || formData.arabicOrganizationName,
      arabicDescription: formData.arabicDescription,
      englishDescription: formData.englishDescription,
      participationType: parseInt(formData.participationType),
      isOnline: formData.location === "online",
      language: parseInt(formData.language),
      contributeOn: dateTime.toISOString(),
      link: formData.link,
    };

    // إعداد FormData
    const formDataObj = new FormData();
    Object.keys(contributionData).forEach((key) => {
      formDataObj.append(key, contributionData[key]);
    });

    // إضافة الصورة إذا كانت موجودة
    if (formData.imagePath) {
      formDataObj.append("imagePath", formData.imagePath); // إضافة الصورة كـ FormData
    }

    try {
      const response = await createContribution(formDataObj);

      toast.success(t("addContributions.successMessage"), {
        autoClose: 3000,
      });

      setTimeout(() => {
        window.location.href = `/my-contributions`;
      }, 3000);
    } catch (error) {
      const errorMessage =
        error.detail || error.title || t("addContributions.errorMessage");
      toast.error(errorMessage);
    }
  };

  const handleImageChange = (e) => {
    setFormData({
      ...formData,
      imagePath: e.target.files[0], // استخدام الملف الذي تم اختياره
    });
  };

  const maxLength = 500;

  const getColorForTextArea = (textLength) => {
    const percentage = (textLength / maxLength) * 100;
    if (percentage < 50) return "green"; // أقل من 50% الأخضر
    if (percentage < 90) return "orange"; // أقل من 90% البرتقالي
    return "red"; // 90% أو أكثر الأحمر
  };

  useEffect(() => {
    fetchContributions();
  }, [page]);

  return (
    <div
      className="tab-pane fade show active"
      id="contributions"
      role="tabpanel"
      aria-labelledby="contributions-tab"
      dir={languageDirection}
    >
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>{t("contributions_management")}</h3>
        <button className="btn btn-primary" onClick={openModal}>
          <i className="fas fa-plus me-2"></i> {t("add_new_Contributions")}
        </button>
      </div>

      {/* جدول المساهمات */}
      <div className="table-responsive">
        <table className="table table-hover">
          <thead className="table-light">
            <tr>
              <th width="70">#</th>
              <th>{t("contribution_title_ar")}</th>
              <th>{t("contribution_type")}</th>
              <th>{t("organization")}</th>
              {/* <th width="100">{t("date")}</th> */}
              <th width="150">{t("actions")}</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(contributionData.items) &&
            contributionData.items.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  <div className="empty-state">
                    <i className="fas fa-award fa-3x mb-3 text-muted"></i>
                    <h5 className="text-muted">
                      {t("noContributionsMessage")}
                    </h5>
                    <p className="text-muted small">{t("add_new_hint")}</p>
                  </div>
                </td>
              </tr>
            ) : (
              contributionData.items.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.arabicTitle}</td>
                  <td>{item.contributionTypeName}</td>
                  <td>{item.arabicOrganizationName}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => {
                        setSelectedItem(item); 
                        setIsModalOpen(true); 
                      }}
                    >
                      <i className="fas fa-edit"></i>
                    </button>

                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(item.id)}
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <AddContributionsModal
        show={isModalOpen}
        onClose={closeModal}
        onSaved={() => {
          fetchContributions(); 
          closeModal(); 
        }}
        initialData={selectedItem}
      />

      <ToastContainer />
    </div>
  );
};

export default ContributionsManagement;
